export const CONTACT_PHONE = "05375022181";
export const CONTACT_PHONE_DISPLAY = "0537 502 21 81";
export const CONTACT_ADDRESS = "Azmimilli Mahallesi, Darıcı Sokak No:18, Düzce Merkez";
export const CONTACT_HOURS = "Her gün · 08:00 — 20:00";
export const WHATSAPP_LINK = "https://wa.me/905375022181?text=Merhaba%20Nova%20Teknik%2C%20cihaz%20ar%C4%B1zam%20i%C3%A7in%20servis%20talebinde%20bulunmak%20istiyorum.";
export const INSTAGRAM_LINK = "https://www.instagram.com/novateknikduzce_";
export const MAPS_LINK = "https://www.google.com/maps/search/?api=1&query=Nova+Teknik+Azmimilli+Mahallesi+Darıcı+Sokak+No:18+Düzce";
export const MAPS_EMBED = "https://www.google.com/maps?q=Nova%20Teknik%20Azmimilli%20Mahallesi%20Dar%C4%B1c%C4%B1%20Sokak%20No%3A18%20D%C3%BCzce&z=16&output=embed";
export const BUSINESS_LINK = "https://share.google/MGPVxZGVfYERKVPbD";
